<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Order Status</h1>
      <br/><br/>
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import auth from '../auth'

export default {
  name: 'OrderStatusView',
  created () {
    auth.checkAuth(['read_orders'])
  }
}
</script>

